import { jsx as _jsx } from "react/jsx-runtime";
import { useOverlayContext, ConfirmationModal } from 'seagull';
import { useStore, useStoreActions } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import { handlePromise } from '~/infra/utils';
import { selectors } from '~/store/state-selectors';
const removeLoader = 'rmPM';
export function useRemovePaymentMethod() {
    const overlayContext = useOverlayContext();
    const isVendor = useStore(selectors.user.isVendor);
    const { api, logBI } = useStoreActions();
    const { t: commonTexts } = useLocaleKeys('common');
    const { t: removeTexts } = useLocaleKeys('hooks.removePaymentMethod');
    function removePaymentMethod(param) {
        let { fundingSourceId, vendorId, customerId } = param;
        const deletePaymentMethod = isVendor ? api.paymentMethod.vendorDelete(fundingSourceId, customerId) : api.paymentMethod.clientDelete(fundingSourceId, vendorId);
        return handlePromise(deletePaymentMethod);
    }
    async function removePaymentMethodWithConfirmation(param) {
        let { fundingSourceId, vendorId, customerId, isCreditCard, last4, onSuccess } = param;
        const confirmed = await overlayContext.showModal({
            biName: 'remove_payment_method_confirm',
            closeOnClickOutside: true,
            closeOnEscapeKey: true,
            content: (param)=>{
                let { dismissModal } = param;
                return /*#__PURE__*/ _jsx(ConfirmationModal, {
                    bi: {
                        primaryButton: {
                            name: 'use_remove_payment_method_confirm'
                        },
                        secondaryButton: {
                            name: 'use_remove_payment_method_cancel'
                        }
                    },
                    title: removeTexts.title({
                        paymentType: isCreditCard ? 'creditCard' : 'bank',
                        hasSuffix: last4 ? 'true' : 'false',
                        last4: last4 !== null && last4 !== void 0 ? last4 : ''
                    }),
                    content: removeTexts.content(),
                    skin: "danger",
                    primaryButtonLabel: commonTexts.buttons.remove(),
                    primaryButtonTestId: "remove-pm-confirm",
                    secondaryButtonLabel: commonTexts.buttons.cancel(),
                    onPrimaryButtonClick: ()=>dismissModal(true),
                    onSecondaryButtonClick: ()=>dismissModal(false)
                });
            }
        });
        if (!confirmed) {
            return;
        }
        overlayContext.startLoader(removeLoader);
        const { success } = await removePaymentMethod({
            fundingSourceId,
            vendorId,
            customerId
        });
        if (!success) {
            overlayContext.showErrorToast(commonTexts.toasts.failedToRemovePaymentMethod(), 'remove-pm-error');
            return overlayContext.stopLoader(removeLoader);
        }
        logBI(isVendor ? 10592 : 10591, {
            fundingSourceId
        });
        try {
            await onSuccess();
        } finally{
            overlayContext.stopLoader(removeLoader);
        }
    }
    return {
        removePaymentMethodWithConfirmation,
        removePaymentMethod
    };
}
